import React, { useEffect, useState } from "react";
import ViewToggle from "../../../../Components/Utils/ViewToggle";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import { useFormik } from "formik";
import * as yup from "yup";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { NuDate } from "../../../../Components/Utils/Input";
import Importdoc from "./Importdoc";
import MultiEditRFQ from "./MultiEditRFQ";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import { GetAccess, GetRole } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import PremiumTable, { CopyButton } from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import ActionButtons from "../../../../Components/Utils/ActionButtons ";
import ModalEmail from "../../../../Components/Others/ModalForEmail";
import EmailModal from "../../../../Components/Utils/EmailModel";

// RFQ Table Row Component
const RFQTableRow = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
  onEmailClick,
}) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handle = async () => handleDelete("/rfq/" + `${row.id}`, setIsModalOpen)
  return (
    <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
      {/* Checkbox */}
      <td className="p-4 text-center align-middle border-t border-b border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onSelect}
          className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
        />
      </td>

      {/* YPR (PR Reference) */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
        <div className="flex items-center gap-1.5">
          <Link
            to={`/procurement/rfq/view/${row.id}`}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            className="hover:underline text-sm font-bold text-gray-800"
          >
            {row.prRef || "N/A"}
          </Link>
          <CopyButton text={row.prRef} />
        </div>
      </td>

      {/* RFQ Type */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
        <Link
          to={`/procurement/rfq/view/${row.id}`}
          state={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className="hover:underline text-xs font-semibold text-gray-500"
        >
          {row.rfqType || "N/A"}
        </Link>
      </td>

      {/* Supplier / Local Purch */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-bold">
        {row.purchaserName ? (
          <span className="text-emerald-600">{row.purchaserName}</span>
        ) : row.vendorName ? (
          <span className="text-rose-600">{row.vendorName}</span>
        ) : (
          <span className="text-gray-400 font-semibold">N/A</span>
        )}
      </td>

      {/* Prepared By */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600">
        {row.preparedByName || "N/A"}
      </td>

      {/* Status */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap">
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Approved" || row.status === "Completed"
          ? "bg-emerald-50 text-emerald-700 border-emerald-100"
          : row.status === "Pending"
            ? "bg-amber-50 text-amber-700 border-amber-100"
            : "bg-gray-50 text-gray-600 border-gray-100"
          }`}>
          {row.status || "N/A"}
        </span>
      </td>

      {/* Action Buttons */}
      <td className="p-4 text-center align-middle border-t border-b border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
        <div className="flex items-center justify-center gap-1.5">
          {/* View */}
          {/* <Link
            to={`/procurement/rfq/view/${row.id}`}
            state={{ data: row }}
            className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
            title="View details"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </Link> */}
          {/* Edit */}
          {/* {canEdit && (
            <Link
              to={`/procurement/rfq/edit/${row.id}`}
              state={{ data: row, from: "/procurement/rfq" }}
              className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Edit RFQ"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </Link>
          )} */}
          {/* Delete */}
          {/* {canDelete && (
            <button
              onClick={() => handleDelete("/rfq/", row.id, row.ref, "RFQ")}
              className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Delete RFQ"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          )} */}
          <ActionButtons
            row={row}
            canEdit={canEdit}
            canDelete={canDelete}
            viewUrl={`/procurement/rfq/view/${row.id}`}
            editUrl={`/procurement/rfq/edit/${row.id}`}
            viewState={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            editState={{
              data: row,
              from: "/procurement/rfq",
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            onDelete={(row) => {
              // setSelectedRow(row);
              setIsModalOpen(true);
            }}
            moduleName="RFQ"
            emailRequired={true}
            emailEnable={row.emailEnable}
            isEmailSent={row.isEmailSent}
            onEmailClick={onEmailClick}
          />
        </div>
      </td>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will removed from PR!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </tr>
  );
};

// RFQ Card Component
const RFQCard = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
  onEmailClick,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/rfq/" + `${row.id}`, setIsModalOpen);
  return (
    <div className="relative border border-y-gray-200/50 border-r-gray-200/50 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-2 sm:p-4 flex flex-col gap-2 sm:gap-4 overflow-hidden border-l-4 border-l-teal-500">
      {/* Card Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:gap-4">
        <div className="flex items-center gap-2.5">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
          <div className="flex flex-col">
            <Link
              to={`/procurement/rfq/view/${row.id}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="text-gray-800 font-bold hover:underline text-sm"
            >
              {row.prRef || "N/A"}
            </Link>
            <span className="text-[10px] text-gray-400 font-bold mt-0.5">Type: {row.rfqType || "N/A"}</span>
          </div>
        </div>

        {/* Status Badge */}
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Approved" || row.status === "Completed"
          ? "bg-emerald-50 text-emerald-700 border-emerald-100"
          : row.status === "Pending"
            ? "bg-amber-50 text-amber-700 border-amber-100"
            : "bg-gray-50 text-gray-600 border-gray-100"
          }`}>
          {row.status || "N/A"}
        </span>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/60 rounded-xl p-3.5 border border-gray-100 flex justify-between items-center gap-2 text-xs">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Supplier/Purchaser</span>
          <span className="font-bold truncate max-w-[150px]">
            {row.purchaserName ? (
              <span className="text-emerald-600">{row.purchaserName}</span>
            ) : row.vendorName ? (
              <span className="text-rose-600">{row.vendorName}</span>
            ) : (
              <span className="text-gray-400">--</span>
            )}
          </span>
        </div>
        <div className="w-[1px] h-8 bg-gray-100" />
        <div className="flex flex-col gap-0.5 flex-1 pl-2">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Prepared By</span>
          <span className="font-bold text-gray-700 truncate max-w-[120px]">{row.preparedByName || "--"}</span>
        </div>
      </div>

      {/* Action Buttons Row */}
      <div className="flex items-center justify-between border-t border-gray-100 pt-3 mt-1 gap-1.5 flex-wrap sm:flex-nowrap">
        <Link
          to={`/procurement/rfq/view/${row.id}`}
          state={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
          title="View Details"
        >
          <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span className="hidden sm:inline">View </span>
        </Link>
        <div className="flex items-center gap-1.5">
          {row.emailEnable && !row.isEmailSent && !row.purchaser && (
            <button
              onClick={() => onEmailClick?.(row)}
              className="border border-purple-100 text-purple-600 hover:bg-purple-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Send Email"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span className="hidden sm:inline">Send Email</span>
            </button>
          )}
          {canEdit && (
            <Link
              to={`/procurement/rfq/edit/${row.id}`}
              state={{
                data: row,
                from: "/procurement/rfq",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Edit"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              <span className="hidden sm:inline">Edit</span>
            </Link>
          )}
          {canDelete && (
            <button
              onClick={() => setIsModalOpen(true)}
              className="border border-red-100 text-red-500 hover:bg-red-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Delete"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              <span className="hidden sm:inline">Delete</span>
            </button>
          )}
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from RFQ!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

function RFQIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [viewMode, setViewMode] = useState(localStorage.getItem("rfqViewMode") || "table");
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 1024);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [emailRow, setEmailRow] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobileScreen ? "card" : viewMode;

  const { value: Status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "status_RFQ",
    showFilterDialog,
  );

  const [filterProps, setFilterProps] = useState({
    status: "",
    fromDate: "",
    toDate: "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    status: "",
    fromDate: "",
    toDate: "",
  });

  const clearFilter = () => {
    setParams({ ...params, status: "", fromDate: "", toDate: "" });
    formik.values.status = "";
    formik.values.fromDate = "";
    formik.values.toDate = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({
        ...params,
        status: value.status,
        fromDate: value.fromDate,
        toDate: value.toDate,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        status: "",
        fromDate: "",
        toDate: "",
      });
    },
  });
  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    "/rfq/",
    params,
  );

  const defaultHeader = [
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/procurement/rfq/view/",
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "RFQ Type",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/procurement/rfq/view/",
      field: "rfqType",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Sup.",
      title2: "Local Purch.",
      mult: true,
      width: "10%",
      field: "vendorNameOrPurchaserName",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Prepared By",
      width: "10%",
      field: "preparedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "ref",
        url: `/rfq/`,
        moduleName: "RFQ",
        from: `/procurement/rfq`,
        editLink: "/procurement/rfq/edit/",
        viewLink: "/procurement/rfq/view/",
        EmailRequired: true,
        emailType: false,
        adminPermmision: true,
      },
    },
  ];
  const availableHeaders = [
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/procurement/rfq/view/",
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "RFQ Type",
      width: "10%",
      isLink: true,
      id: "id",
      link: "/procurement/rfq/view/",
      field: "rfqType",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Supplier",
      width: "10%",
      field: "vendorName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Local Purchaser",
      width: "10%",
      field: "purchaserName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Prepared By",
      width: "10%",
      field: "preparedByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer Reference",
      width: "10%",
      field: "customerRfq",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "ref",
        url: `/rfq/`,
        moduleName: "RFQ",
        from: `/procurement/rfq`,
        editLink: "/procurement/rfq/edit/",
        viewLink: "/procurement/rfq/view/",
        EmailRequired: true,
        emailType: false,
      },
    },
  ];
  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const closeModal = () => {
    setShowImportModal(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.id);
      });
    setFullList(tempArr);
  }, [data]);

  const canEdit = GetAccess("rfq_edit") || GetRole();
  const canDelete = GetAccess("rfq_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  return (
    <div className="w-full h-full px-2 sm:px-4 py-2">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb items={[{ name: "Procurement" }, { name: "RFQ" }]} />
          <div className="flex md:hidden items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetAccess("rfq_create") && (
              <Link to="/procurement/rfq/create">
                <CreateButton label="RFQ" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2">
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
          </div>

          {/* Table / Card View Toggle */}
          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="rfqViewMode"
          />

          <div className="hidden md:flex items-center gap-2">
            {GetAccess("rfq_create") && (
              <Link to="/procurement/rfq/create">
                <CreateButton label="RFQ" />
              </Link>
            )}
          </div>
        </div>
      </div>
      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        // viewMode={viewMode}
        viewMode={effectiveViewMode}
        headers={[
          { title: "YPR", width: "160px" },
          { title: "RFQ Type", width: "150px" },
          {
            title: (
              <span className="inline-flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full bg-rose-500"></span>
                Sup. /
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                Local Purch.
              </span>
            ),
            width: "auto"
          },
          { title: "Prepared By", width: "180px" },
          { title: "Status", width: "140px" },
          { title: "Action", align: "center", width: "100px" }
        ]}
        renderRow={(row, idx) => (
          <RFQTableRow
            row={row}
            isSelected={listofNumbers.includes(row.id)}
            onSelect={() => selectOneFunction(row.id)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            onEmailClick={(r) => {
              setEmailRow(r);
              setEmailModalOpen(true);
            }}
          />
        )}
        renderCard={(row, idx) => (
          <RFQCard
            row={row}
            isSelected={listofNumbers.includes(row.id)}
            onSelect={() => selectOneFunction(row.id)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            onEmailClick={(r) => {
              setEmailRow(r);
              setEmailModalOpen(true);
            }}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        multiEditLabel="Multi Edit"
      />
      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[500px] md:w-[600px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter RFQ</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-3">
              <div className="flex flex-col mb-4">
                <p className="text-xs font-semibold text-gray-700 mb-1">Date Range</p>
                <div className="md:flex gap-2 mb-3">
                  <NuDate
                    label="From"
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="fromDate"
                    width="md:w-1/2"
                  />
                  <NuDate
                    label="To"
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="toDate"
                    width="md:w-1/2"
                  />
                </div>
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Status"
                  Options={Status}
                  formik={formik}
                  name="status"
                  width="w-full"
                />
              </div>
              <div className="flex justify-end gap-2.5 pt-4 mt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && (
        <Importdoc
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}
      {showEdit && (
        <MultiEditRFQ
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
      <ModalEmail
        visiable={emailModalOpen}
        title=""
        hasContent={true}
        content={
          <EmailModal
            fetcher={getData}
            vendorId={emailRow?.vendor || emailRow?.vendorId}
            id={emailRow?.id}
            url="/rfq/"
            idd={emailRow?.id}
            onClose={() => setEmailModalOpen(false)}
            emailType={false}
          />
        }
        hasButton={false}
        closeModal={() => setEmailModalOpen(false)}
      />
    </div>
  );
}

export default RFQIndex;
